import Flex from '@Components/Bases/Flex';
import SearchCheckboxList from '@Components/SearchCheckboxList';
import { IInfoCategoryMasterData } from '@Domains/MasterData';
import { Box, InputLabel, Typography } from '@mui/material';
import Tags from '@Router/ImpactsOnStakeholdersManagement/Containers/StakeholderAnalysisValueChainOfBusiness/ModalAddStakeholderAnalysis/Tags';
import { useState } from 'react';
import FormCheckboxList from './FormCheckboxList';
import InputOtherSection from './InputOtherSection';

type StakeholderCheckboxListProps = {
  name: string;
  value: IInfoCategoryMasterData[];
  isCompletedTh?: boolean;
  isCompletedEn?: boolean;
};

const StakeholderCheckboxList = ({
  value,
  name,
  isCompletedTh,
  isCompletedEn,
}: StakeholderCheckboxListProps) => {
  const [filterText, setFilterText] = useState<string>('');
  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilterText(event.target.value);
  };

  const filteredStakeholders = value.filter((stakeholder) =>
    stakeholder.nameTh.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <Box width={1}>
      <Typography fontWeight={'bold'} mb={2}>
        กลุ่มผู้มีส่วนได้เสีย
      </Typography>
      <Flex>
        <Box flex={1}>
          <InputLabel
            sx={{
              textAlign: 'right',
              marginRight: 2,
            }}
            required
          >
            กลุ่มผู้มีส่วนได้เสีย
          </InputLabel>
        </Box>
        <Flex flexDirection={'column'} width={1} maxWidth={600}>
          <Tags disabled={isCompletedEn || isCompletedTh} name={name} />
          <Typography mb={1}>
            เลือกผู้มีส่วนได้เสีย (เลือกได้หลายข้อ)
          </Typography>
          <SearchCheckboxList
            filterText={filterText}
            handleChange={handleFilterChange}
          />
          <FormCheckboxList
            disabled={isCompletedEn || isCompletedTh}
            name={name}
            filter={filteredStakeholders}
          />
          <InputOtherSection
            name="otherStakeholders"
            title="กลุ่มผู้มีส่วนได้เสียอื่น ๆ (ถ้ามี)"
            isCompletedTh={isCompletedTh}
            isCompletedEn={isCompletedEn}
          />
        </Flex>
      </Flex>
    </Box>
  );
};

export default StakeholderCheckboxList;
